import { render, staticRenderFns } from "./operationNav.vue?vue&type=template&id=5f1be5b8&"
import script from "./operationNav.vue?vue&type=script&lang=js&"
export * from "./operationNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/syncScreen/operationNav.vue"
export default component.exports